(function() { window.GUID_9a3cdbc9_42c3_4b02_9ec9_493d5d326427 = { getGuid: function() { return "9a3cdbc9-42c3-4b02-9ec9-493d5d326427"; } }; })();
/** Server access of the score sheet finder. */
class ScoreSheetFinderApi {
    constructor() { }
    /**
     * Posts the filter request built by the store and hands the results back.
     * The callback is not invoked when the server answers with something else than a
     * list of results, so that the finder keeps the results it already has.
     */
    static filter(request, callback) {
        try {
            CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetFinder/Filter/", request, function (response) {
                try {
                    if (!Array.isArray(response)) {
                        throw new Error("Response is not an array");
                    }
                    callback(response);
                }
                catch (error) {
                    console.error("Error while filtering score sheets", error);
                }
            });
        }
        catch (error) {
            console.error("Error while filtering score sheets", error);
        }
    }
    /**
     * Fetches the content of both drawers. Their markup is rendered by partial views
     * and injected into the drawers once loaded.
     */
    static getDrawersContent(filters, callback) {
        try {
            CompuSport.Ajax.Get("/ScoreSheetFinder/AdvancedFiltersDrawer", {}, function (advancedFiltersDrawerContent) {
                CompuSport.Ajax.Get("/ScoreSheetFinder/RoundRotationsDrawer", filters, function (rotationsDrawerContent) {
                    callback({
                        advancedFiltersDrawerContent: advancedFiltersDrawerContent,
                        rotationsDrawerContent: rotationsDrawerContent,
                    });
                });
            });
        }
        catch (error) {
            console.error("Error while fetching drawer content", error);
        }
    }
}

//# sourceMappingURL=ScoreSheetFinderApi.js.map
